import React from "react";
import styled from "styled-components";
const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
const ListGroup = ({
  "aria-label": ariaLabel = void 0,
  bsClass = void 0,
  children = void 0,
  className = void 0,
  componentClass = void 0,
  "data-testid": dataTestId = void 0,
  style = void 0
}) => /* @__PURE__ */ React.createElement(
  StyledList,
  {
    as: componentClass,
    "aria-label": ariaLabel,
    className: `${className != null ? className : ""} ${bsClass != null ? bsClass : ""}`,
    style,
    "data-testid": dataTestId
  },
  children
);
export default ListGroup;
